import React from "react";
import { EstadoContenido } from "../../../../utils/constants";
import { ConfiguracionLogosPage } from "..";

const LogosNuevoPage = () => (
  <ConfiguracionLogosPage estado={EstadoContenido.EnRevision} nuevo />
);

export default LogosNuevoPage;
